import PurchasePriceReports from './PurchasePriceReports';

export default PurchasePriceReports;
